export enum RolesEnum {
  USER = 'user',
  OPERATOR = 'operator',
  ADMIN = 'admin',
  OWNER = 'owner',
  AUTHENTICATED = 'authenticated',
  OBSERVER = 'observer',
}

export type BaseRole = {
  type: RolesEnum;
  name: string;
  id: number;
};
